import { optionalFeaturesOf, type SocialConnection } from '@mg/shared';

/**
 * True for a connected Instagram account that was connected with Instagram Login and does not hold
 * BOTH permissions the Messages inbox needs (reading messages, and reading and answering comments).
 * Its messages, comments and mentions cannot appear until "Enable inbox" is chosen on Connections.
 *
 * Never an Instagram account connected through Facebook: that sign-in asks for its inbox permissions
 * from the start, and has nothing to turn on. Decided from the permissions the connection stores,
 * by the same rule the server uses - which names an inbox option for Instagram Login only, so no
 * other platform's account is ever one of these.
 */
export function lacksInstagramInbox(conn: SocialConnection): boolean {
  return conn.connected && optionalFeaturesOf(conn.platform, conn.scopes).inbox === false;
}

/** The connections {@link lacksInstagramInbox} is true for, in the order given. */
export function instagramAccountsWithoutInbox(connections: SocialConnection[]): SocialConnection[] {
  return connections.filter(lacksInstagramInbox);
}
